import type { FormDefinition } from '../format/form-definition';
import { CURRENT_FORMAT_VERSION } from '../format/migrations';

export const UNTITLED_FORM = 'Untitled form';

export const newFormDefinition = (): FormDefinition => {
  return { formatVersion: CURRENT_FORMAT_VERSION, title: UNTITLED_FORM, elements: [] };
};
